var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4998 7.99918C13.4998 4.96161 11.0373 2.49918 7.99976 2.49918C4.96219 2.49918 2.49976 4.96161 2.49976 7.99918C2.49976 11.0367 4.96219 13.4992 7.99976 13.4992C11.0373 13.4992 13.4998 11.0367 13.4998 7.99918ZM14.4998 7.99918C14.4998 11.589 11.5896 14.4992 7.99976 14.4992C4.4099 14.4992 1.49976 11.589 1.49976 7.99918C1.49976 4.40933 4.4099 1.49918 7.99976 1.49918C11.5896 1.49918 14.4998 4.40933 14.4998 7.99918ZM8.26629 4.29918C8.40487 4.29918 8.53696 4.35706 8.63153 4.45835C8.72604 4.55961 8.77478 4.69518 8.76532 4.83335L8.49871 8.70054C8.48049 8.96257 8.26239 9.16539 7.99969 9.16539C7.73702 9.16535 7.51888 8.96255 7.50067 8.70054L7.23407 4.83335C7.2246 4.6952 7.27338 4.5596 7.36785 4.45835C7.46242 4.35705 7.59451 4.29918 7.73309 4.29918H8.26629ZM8.79976 10.9325C8.79976 11.3743 8.44158 11.7325 7.99976 11.7325C7.55793 11.7325 7.19976 11.3743 7.19976 10.9325C7.19976 10.4907 7.55793 10.1325 7.99976 10.1325C8.44158 10.1325 8.79976 10.4907 8.79976 10.9325Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.59b7611bfd4f48ac65da885eb2df2be0.svg";
export { ForwardRef as ReactComponent };